import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const BlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to blog list page - all blog interactions now happen through the advanced popup
    navigate('/blog', { replace: true });
  }, [navigate]);

  return null; // Component just redirects
};

export default BlogPost; 